<div class="rules-container" *ngIf="content$ | async as content">
  <div class="top-section">
    <app-tenant-hero-image
      class="rules-hero-background"
      worldLeagueImageUrl="/assets/thumbnail-3-e1712872432876.jpg"
    ></app-tenant-hero-image>
    <div class="overlay">
      <div class="container">
        <h1 class="page-title">
          <span class="title-top">{{ content.rules.titleTop }}</span>
          <span class="title-bottom">RULES & REGULATIONS</span>
        </h1>
        <p class="page-subtitle font-sm">
          {{ content.rules.subtitle }}
        </p>
      </div>
    </div>
  </div>

  <div class="container">
    @if (content.rules.policy.mode === 'unavailable') {
      <section class="policy-unavailable" aria-labelledby="rules-unavailable-title">
        <h2 id="rules-unavailable-title" class="section-title font-hd">Policy unavailable</h2>
        <p class="section-text font-sm">{{ content.rules.policy.unavailableMessage }}</p>
        @if (content.rules.policy.supportMailto) {
          <a [href]="content.rules.policy.supportMailto">Contact {{ content.rules.policy.supportEmail }}</a>
        }
      </section>
    } @else {
      @if (content.rules.policy.document.introduction || content.rules.policy.document.show_fiba_resource) {
        <section class="fiba-section">
          <h2 class="section-title font-hd">FIBA RULES MODIFICATION</h2>
          @if (content.rules.policy.document.introduction) {
            <p class="section-text policy-pre-line font-sm">{{ content.rules.policy.document.introduction }}</p>
          }
          @if (content.rules.policy.document.show_fiba_resource) {
            <a [href]="officialFibaRulesUrl" target="_blank" rel="noopener noreferrer" class="fiba-link">{{ officialFibaRulesUrl }}</a>
          }
        </section>
      }

      <section class="rules-grid" aria-label="Rules and regulations sections">
        @for (section of content.rules.policy.document.sections; track $index) {
          <article class="rule-card" [class.policy-notice]="section.kind === 'notice'">
            <h2 class="rule-title font-hd">{{ section.heading }}</h2>
            @if (section.body) {
              <p class="section-text policy-pre-line font-sm">{{ section.body }}</p>
            }
            @if (section.items.length) {
              <ul class="rule-list font-sm">
                @for (item of section.items; track $index) {
                  <li>{{ item.text }}
                    @if (item.subitems.length) {
                      <ul>
                        @for (subitem of item.subitems; track $index) { <li>{{ subitem }}</li> }
                      </ul>
                    }
                  </li>
                }
              </ul>
            }
          </article>
        }
      </section>
    }
  </div>
</div>

<app-footer></app-footer>

